export default __webpack_public_path__ + "static/dallas_banner-2ab3235bdd2052d6fc4bcb25b745026b.webp";